// ALL PLATFORM COLORS SHOULD LIVE HERE
// CAN BE CALLED IN less files via "var(--NAMED_COLOR)"
// EG background-color: var(--botticelli-blue)
// OR IN TS/TSX files via "theme.colors.NAMED_COLOR"
// EG `theme.colors.downriverBlueA90` OR (old way) theme.colors["picton-blue"]
// Names typically come from https://chir.ag/projects/name-that-color/#20C2F1
// Naming convention should prefer lower-camel-case.
// WHEN IN DOUBT, DON'T ADD A COLOR. USE AN EXISTING ONE!

const blues = {
  "modal-overlay-blue": "rgba(11, 47, 95, 0.75)",
  "dark-blue": "rgba(41, 92, 160)" /* #295CA0 */,
  "dark-blue-a07": "rgba(41, 92, 160, .07)",
  "font-color-eastern-blue-highlighted": "rgb(80, 117, 165)" /* "#295CA0" */,
  "picton-blue": "rgba(32, 194, 241, 1)" /* #20C2F1: POWUR GUIDE PRIMARY-1 */,
  "picton-blue-a20": "rgba(32, 194, 241, 0.2)" /* , #20C2F1": */,
  "picton-blue-a10": "rgba(32, 194, 241, 0.1)" /* , #20C2F1": */,
  pictonBlueA12: "rgba(32, 194, 241, 0.12)",
  pictonBlueA18: "rgba(32, 194, 241, 0.18)",
  pictonBlueA22: "rgba(32, 194, 241, 0.22)",
  pictonBlueA30: "rgba(32, 194, 241, 0.30)",
  pictonBlueA40: "rgba(32, 194, 241, 0.40)",
  pictonBlueA45: "rgba(32, 194, 241, 0.45)",
  pictonBlueA50: "rgba(32, 194, 241, 0.50)",
  "picton-blue-highlighted": "rgb(73, 207, 244)" /*  #20C2F1 */,
  "blue-ribbon": "rgba(0, 112, 244, 1)" /* #0070F4": POWUR GUIDE PRIMARY-3 */,
  "blue-ribbon-a05": "rgba(0, 112, 244, .05)" /* , #0070F4", */,
  "blue-ribbon-a15": "rgba(0, 112, 244, .15)" /* , #0070F4", */,
  "blue-ribbon-a20": "rgba(0, 112, 244, .20)" /* , #0070F4", */,
  "blue-ribbon-a07": "rgba(0, 112, 244, .07)" /* , #020202ff", */,
  "blue-ribbon-a10": "rgba(0, 112, 244, 0.1)" /* #0070F4 */,
  blueRibbonA08: "rgba(0, 112, 244, 0.08)",
  blueRibbonA12: "rgba(0, 112, 244, 0.12)",
  blueRibbonA22: "rgba(0, 112, 244, 0.22)",
  blueRibbonA18: "rgba(0, 112, 244, 0.18)",
  "banner-blue": "rgb(40, 136, 246)" /* , #2888F6", */,
  "dark-navy": "rgb(29, 74, 135)" /*  #1D4A87 */,
  "cotton-boll-highlighted": "#C8DBF5",
  "darker-blue": "rgba(31, 50, 80, 1)" /* #1F3250 */,
  "darkest-blue": "rgb(0, 33, 96)" /* #002160 */,
  "background-blue": "#0980a0",
  "institutional-grey-hover": "#93A8C3",
  "institutional-grey": "#657A96",
  "gothic-blue": "rgba(116, 154, 169, 1)" /* #749AA9 */,
  "nepal-blue": "rgba(132, 153, 183, 1)" /* #8499B7 */,
  "nepal-blue-a10": "rgba(132, 153, 183, 0.1)" /* #8499B7 */,
  nepalBlueA18: "rgba(132, 153, 183, 0.18)",
  nepalBlueA20: "rgba(132, 153, 183, 0.20)",
  "slate-turquoise": "rgba(156, 197, 212)" /* #9CC5D4 */,
  "botticelli-blue": "rgba(214, 225, 240, 1)" /* #D6E1F0 */,
  "botticelli-blue-35": "rgba(214, 225, 240, .35)" /* #D6E1F0 */,
  "botticelli-blue-50": "rgba(214, 225, 240, .5)" /* #D6E1F0 */,
  "botticelli-green-a25": "rgba(214, 225, 240, 0.25)" /* #D6E1F0 */,
  "primary-color": "rgba(91, 170, 227, 1)" /* #5BAAE3 */,
  "primary-color-highlighted": "rgb(123, 182, 223)" /* #5BAAE3 */,
  "primary-color-a10": "rgba(91, 170, 227, 0.1)" /* #5BAAE3 */,
  "primary-color-a15": "rgba(91, 170, 227, 0.15)" /* #5BAAE3 */,
  "primary-color-a30": "rgba(91, 170, 227, 0.3)" /* #5BAAE3 */,
  "primary-lite": "rgb(0, 161, 207)" /*  #00A1CF */,
  "primary-lite-highlighted": "rgb(44, 184, 223)" /*  #00A1CF */,
  "light-cyan": "#a4e9fd",
  "queen-blue": "rgba(81, 102, 131, 1)" /* #516683 */,
  "clear-sky-lite": "#f2fdff",
  "table-badge-people": "#dfecf1" /*  rgba(223, 236, 241, 1) */,
  "table-badge-team": "rgba(104, 1, 130, 1)" /* #680182 */,
  "clear-sky": "rgb(199, 230, 241)" /*  #c7e6f1 */,
  "light-navy": "rgb(17, 132, 173)" /*  #1184AD */,
  "light-baby-blue": "rgb(237, 243, 245)" /*  #F5EDF3 */,
  "slashee-blueberry": "rgb(77, 205, 244)" /* #4dcdf4 */,
  "madison-blue": "rgba(11, 47, 95, 1)" /* #0B2F5F */,
  "rock-blue": "rgba(156, 175, 201, 1)" /* #9CAFC9 */,
  "pewter-blue": "rgba(141, 177, 191, 1)" /* #8DB1BF */,
  "malibu-blue": "rgba(95, 204, 242, 1)" /* #5FCCF2 */,
  "bright-turquoise": "rgba(33, 194, 242, 1)" /* #21C2F2 */,
  "royal-peacock-blue": "rgba(41, 170, 227, 1)" /* #29AAE3 */,
  "royal-peacock-blue-a10": "rgba(41, 170, 227, 0.1)" /* #29AAE3 */,
  "astronaut-blue": "rgba(42, 52, 118, 1)" /* #2A3476 */,
  "adamantine-blue": "rgba(65, 177, 245, 1)" /* #41B1F5 */,
  "lavender-blue": "rgba(191, 219, 252, 1)" /* #BFDBFC */,
  "bahama-blue": "rgba(1, 97, 146, 1)" /* #016192 */,
  frostproof: "rgba(211, 240, 247, 1)" /* #D3F0F7 */,
  "lake-thun": "rgba(75, 188, 222, 1)" /* #4BBCDE */,
  "adriatic-sea": "rgba(1, 97, 130, 1)" /* #016182 */,
  "dodger-blue": "rgba(24, 144, 255, 1)" /* #1890FF */,
  bluejay: "rgba(22, 138, 177, 1)" /* #168AB1 */,
  "cameo-blue": "rgba(110, 148, 163, 1)" /* #6E94A3 */,
  "steel-blue": "rgba(70, 136, 161, 1)" /* #4688A1 */,
  "chambray-blue": "rgba(52, 77, 147, 1)" /* #344D93 */,
  "rockman-blue": "rgba(59, 161, 233, 1)" /* #3BA1E9 */,
  "hawkes-blue": "rgba(228, 240, 252, 1)" /* #E4F0FC */,
  "bubbles-blue": "rgba(227, 248, 255, 1)" /* #E3F8FF */,
  "dreaming-blue": "rgba(140, 193, 214, 1)" /* #8CC1D6 */,
  "cyan-blue-azure": "rgba(75, 129, 201, 1)" /* #4B81C9 */,
  "coastal-breeze-blue": "rgba(225, 245, 252, 1)" /* #E1F5FC */,
  "twilight-blue": "rgba(240, 253, 255, 1)" /* #F0FDFF */,
  "polar-blue": "rgba(231, 243, 250, 1)" /* #E7F3FA */,
  "polar-blue-light": "rgba(231, 243, 250, 0.5)" /* #E7F3FA */,
  "bondi-blue": "rgba(2, 142, 181, 1)" /* #028EB5 */,
  "blue-purple-hover": "#2E10A6",
  "congress-blue": "rgba(7, 70, 154, 1)" /* #07469A: POWUR GUIDE SECONDARY-2 */,
  "congress-blue-50": "rgba(7, 70, 154, 0.5)" /* #07469A */,
  "diamond-blue": "rgba(206, 229, 238, 1)" /* #CEE5EE */,
  "blue-silk": "rgba(208, 218, 233, 1)" /* #D0DAE9 */,
  "forever-blue": "rgba(132, 154, 184, 1)" /* #849AB8 */,
  "seagull-blue": "rgba(120, 201, 230, 1)" /* #78C9E6 */,
  "blueberry-blue": "rgba(66, 133, 244, 1)" /* #4285F4 */,
  "curious-blue": "rgba(38, 165, 210, 1)" /* #26A5D2 */,
  "fresh-air-blue": "rgba(163, 233, 253, 1)" /* #A3E9FD */,
  "deep-sky-blue": "rgba(23, 123, 245, 1)" /* #177BF5 */,
  "maya-blue": "rgba(33, 166, 242, 1)" /* #21A6F2 */,
  "holiday-blue": "rgba(38, 189, 210, 1)" /* #26BDD2 */,
  "cloudy-blue": "rgba(169, 192, 219, 1)" /* #A9C0DB */,
  "downriver-blue": "rgba(13, 45, 82, 1)" /* #0D2D52: POWUR GUIDE SECONDARY-3 */,
  downriverBlueA90: "rgba(13, 45, 82, 0.9)" /* #0D2D52 */,
  "cotton-boll": "rgba(232, 240, 252, 1)" /* #E8F0FC */,
  "banner-blue-highlighted": "rgba(0, 93, 203, 1)" /* #005DCB */,
  "dark-blue-highlighted": "#124180",
  "mangus-blue-hover": "#004EAB",
  "blue-bayoux-a10": "rgba(81, 102, 131, 0.10)" /* #516683 */,
  "blue-bayoux-a22": "rgba(81, 102, 131, 0.22)" /* #516683 */,
  "alice-blue": "#EDF5FE",
  "cobalt-blue": "#0053B5",
  "clear-skies": "#E9F9FE",
  "move-it-forward-disabled": "rgba(0, 112, 244, 0.3)",
  "husky-blue": "#E2EDFB",
  "blue-estate": "#3E4784",
  "zumthor-blue": "#E8F2FF",
  brandeisBlue: "rgba(0, 111, 255, 1)" /* #006FFF */,
  antdButtonHover: "#40a9ff",
  royalBlueLight: "rgba(59, 130, 246, 1)" /* #3B82F6 */,
  darkTurquoise: "rgba(6, 182, 212, 1)" /* #06B6D4 */,
  allports: "rgba(14, 116, 144, 1)" /* #0E7490 */,
  darkNavy: "rgba(10, 26, 58, 1)" /* #0A1A3A */,
  darkNavyAlt: "rgba(10, 30, 56, 1)" /* #0A1E38 */,
  darkMidnight: "rgba(8, 24, 48, 1)" /* #081830 */,
  cobaltBlueBright: "rgba(0, 96, 208, 1)" /* #0060D0 */,
  aliceBlueGhost: "rgba(240, 244, 255, 1)" /* #F0F4FF */,
  oliveBlackWarm: "rgba(26, 22, 8, 1)" /* #1A1608 */,
  espressoBlack: "rgba(20, 16, 10, 1)" /* #14100A */,
  midnightPurple: "rgba(12, 10, 20, 1)" /* #0C0A14 */,
  cobaltBright: "#0064DC",
  lynchBlue: "#5A6B82",
  oxfordNavy: "#081A3D",
  oxfordNavyA92: "rgba(8, 26, 61, 0.92)",
  deepSapphire: "#0C2150",
  midnightSapphire: "#0A1B43",
  navyInk: "#091F4B",
  sapphireBlue: "#0E2C66",
  royalNavy: "#0E255A",
  cobaltNavy: "#102859",
  bayOfManyBlue: "#0A2D6E",
  toryBlue: "#0D3B8C",
  eclipseNavy: "#04102A",
  midnightNavy: "#07173A",
  sapphireMid: "#0E2E66",
  azureBright: "#2A8BF7",
  zirconWhite: "#F4F8FF",
  casperBlue: "#B7C5DE",
  baliHaiBlue: "#8A9AB8",
  kashmirBlue: "#5E6E8F",
  spindleBlue: "#A8B6CD",
  periwinkleGray: "#B6C4DD",
};

const yellows = {
  goldenrod: "rgba(244, 199, 81, 1)" /* #F4C751: POWUR GUIDE PRIMARY-2 */,
  goldenrodA20: "rgba(244, 199, 81, 0.20)",
  goldenrodA22: "rgba(244, 199, 81, 0.22)",
  "goldenrod-text": "rgba(92, 63, 0, 1)" /* #5C3F00: dark amber text on goldenrod */,
  corn: "rgba(212, 204, 0, 1)" /*  #D4CC00 */,
  "button-yellow": "#ffc001",
  pumpkin: "rgba(248, 124, 9, 1)" /* #F87C09 */,
  "pumpkin-a10": "rgba(248, 124, 9, 0.1)" /* #F87C09 */,
  "pumpkin-light": "#FFEFE0",
  "pumpkin-highlighted": "rgba(249, 150, 58, 1)" /* #f9963a */,
  "status-alert-fill": "#DF6B00",
  "status-alert-fill-a22": "rgba(223, 107, 0, 0.22)" /* #DF6B00 */,
  "pumpkin-dark": "#cf7c00",
  "canary-yellow": "rgba(249, 255, 174, 1)" /* #F9FFAE */,
  "canary-yellow-a50": "rgba(249, 255, 174, 0.5)" /* #F9FFAE */,
  "lemon-chiffon": "rgba(251, 255, 206, 1)" /* #FBFFCE */,
  "mellow-apricot": "rgba(255, 191, 112, 1)" /* #FFBF70 */,
  "sun-splashed": "rgba(250, 216, 149, 1)" /* #FAD895 */,
  "sultan-gold": "rgba(250, 173, 20, 1)" /* #FAAD14 */,
  "sultan-gold-a10": "rgba(250, 173, 20, 0.1)" /* #FAAD14 */,
  "sahara-gold": "rgba(170, 147, 19, 1)" /* #AA9313 */,
  "energy-yellow": "rgba(251, 224, 83, 1)" /* #FBE053 */,
  "seed-pod-yellow": "rgba(221, 195, 58, 1)" /* #DDC33A */,
  "selective-yellow": "rgba(251, 188, 5, 1)" /* #FBBC05 */,
  "candy-corn": "rgba(252, 227, 98, 1)" /* #FCE362 */,
  "golden-grass": "rgba(206, 179, 34, 1)" /* #CEB322 */,
  "tangerine-yellow": "rgba(241, 203, 0, 1)" /* #F1CB00 */,
  "light-yellow": "rgb(252, 255, 214)" /* #FCFFD6 */,
  gold: "rgba(255, 215, 0, 1)" /* #FFD700 */,
  amber: "rgba(245, 158, 11, 1)" /* #F59E0B */,
  darkGoldenrod: "rgba(212, 165, 32, 1)" /* #D4A520 */,
  piratGold: "rgba(184, 137, 26, 1)" /* #B8891A */,
  creamGold: "rgba(251, 233, 138, 1)" /* #FBE98A */,
  darkHarvestGold: "rgba(212, 147, 10, 1)" /* #D4930A */,
  cornSilk: "rgba(255, 251, 235, 1)" /* #FFFBEB */,
  antiqueWhiteLight: "rgba(252, 244, 232, 1)" /* #FCF4E8 */,
  salomieGold: "#F8D470",
  goldenAmber: "rgba(233, 164, 0, 1)" /* #E9A400 */,
};

const reds = {
  scarlet: "rgba(222, 95, 82, 1)" /* #DE5F52 */,
  "scarlet-a11": "rgba(222, 95, 82, 0.11)" /* #DE5F52 */,
  "halt-red-orange": "rgb(218, 86, 30)" /*  #DA561E */,
  "safety-orange": "rgb(245, 103, 0)" /* #f56700 */,
  "safety-orange-a20": "rgb(245, 103, 0, 0.2)" /* #f56700 */,
  "table-button-cancel": "rgba(253, 145, 142, 1)" /* #fd918e */,
  "table-button-cancel-highlighted": "rgb(249, 173, 170)" /* #fd918e */,
  "heliotrope-magenta": "rgba(183, 12, 165, 1)" /* #B70CA5 */,
  "heliotrope-magenta-a10": "rgba(183, 12, 165, 0.1)" /* #B70CA5 */,
  coral: "rgba(255, 131, 85, 1)" /* #FF8355 */,
  "dark-pink": "rgba(255, 0, 73, 1)" /* FF0049 */,
  "fire-red": "rgba(190, 57, 0, 1)" /* #BE3900 */,
  "web-orange": "rgba(255, 170, 0, 1)" /* #FFAA00 */,
  "guardsman-red": "rgba(204, 0, 0, 1)" /* #CC0000 */,
  "pomegranate-red": "rgba(240, 64, 11, 1)" /* #F0400B */,
  "congo-pink": "rgba(255, 136, 120, 1)" /* #FF8878 */,
  "monarch-red": "rgba(145, 7, 14, 1)" /* #91070E */,
  "pesto-rosso": "rgba(186, 52, 52, 1)" /* #BA3434 */,
  "ballerina-pink": "rgba(246, 184, 184, 1)" /* #F6B8B8 */,
  "ghost-pepper-red": "rgba(195, 1, 0, 1)" /* #C30100 */,
  cinnabar: "rgba(234, 67, 53, 1)" /* #EA4335 */,
  "torch-red": "rgba(255, 0, 57, 1)" /* #FF0039 */,
  "ferrari-red": "rgba(224, 42, 2, 1)" /* #E02A02 */,
  "tijolo-red": "rgba(174, 83, 0, 1)" /* #AE5300 */,
  "persian-red": "rgba(211, 47, 47, 1)" /* #D32F2F */,
  raspberry: "rgba(255, 0, 107, 1)" /* #FF006B */,
  "raspberry-highlighted": "#DE005D",
  "brick-red-a12": "rgba(207, 48, 48, 0.12)" /* #cf3030 */,
  danger: "rgba(202, 0, 0, 1)" /* #CA0000 */,
  "foam-green": "rgba(237, 253, 248, 1)" /* #EDFDF8 */,
  watermelon: "rgba(255, 102, 119, 1)" /* #FF6677 */,
  "watermelon-a10": "rgba(255, 102, 119, 0.1)" /* #FF6677 */,
  bridesmaid: "#FEF1F2" /* #FEF1F2 */,
  "fair-pink": "#FFE8E9" /* #FFE8E9 */,
  redSalsa: "rgba(239, 68, 68, 1)" /* #EF4444 */,
  redSalsa40: "rgba(239, 68, 68, 0.4)" /* #EF4444 */,
  snowPink: "rgba(254, 242, 242, 1)" /* #FEF2F2 */,
  melon: "rgba(254, 202, 202, 1)" /* #FECACA */,
  lavenderBlush: "rgba(255, 240, 248, 1)" /* #FFF0F8 */,
  pinkLace: "rgba(252, 232, 240, 1)" /* #FCE8F0 */,
  mistyRose: "rgba(255, 205, 210, 1)" /* #FFCDD2 */,
  firebrick: "rgba(198, 40, 40, 1)" /* #C62828 */,
  roseWhite: "rgba(255, 235, 238, 1)" /* #FFEBEE */,
  roseFog: "rgba(254, 226, 226, 1)" /* #FEE2E2 */,
  mahogany: "rgba(153, 27, 27, 1)" /* #991B1B */,
};

const greens = {
  "sweet-mint": "rgba(81, 242, 203)" /* #51F2CB: POWUR GUIDE SECONDARY-1 (Turquoise Blue) */,
  "caribbean-green": "rgba(12, 201, 168, 1)" /*  #0CC9A8 */,
  "harlequin-green": "rgb(71, 195, 76)" /*  #47C34C */,
  "harlequin-green-highlighted": "rgb(113, 210, 116)" /*  #47C34C */,
  mint: "rgb(133, 228, 163)" /*  #85E4A3 */,
  evergreen: "rgba(78, 190, 104, 1)" /* #4ebe68 */,
  "evergreen-a85": "rgba(78, 190, 104, 0.85)" /* #4ebe68 */,
  lime: "rgba(130, 232, 128, 1)" /* #82E880 */,
  "green-haze": "rgba(1, 158, 111, 1)" /* #019E6F */,
  "green-haze-a10": "rgba(1, 158, 111, 0.1)" /* #019E6F */,
  greenHazeA12: "rgba(1, 158, 111, 0.12)",
  "green-haze-highlighted": "#01815A",
  "green-haze-button-highlighted": "#006A4A",
  "key-lime-pie": "rgba(186, 210, 38, 1)" /* #BAD226 */,
  "channel-marker-green": "rgba(0, 214, 176, 1)" /* #00D6B0 */,
  "channel-marker-green-a08": "rgba(0, 214, 176, 0.08)" /* #00D6B0 */,
  "channel-marker-green-a10": "rgba(0, 214, 176, 0.1)" /* #00D6B0 */,
  "sea-green": "rgba(0, 168, 138, 1)" /* #00A88A */,
  "kelly-green": "rgba(82, 196, 26, 1)" /* #52C41A */,
  "forest-green": "rgba(39, 135, 45, 1)" /* #27872D */,
  "slime-lime": "rgba(183, 240, 189, 1)" /* #B7F0BD */,
  "chateau-green": "rgba(52, 168, 83, 1)" /* #34A853 */,
  "commission-credit": "#41A81D",
  "everbright-green": "rgba(100, 174, 108, 1)" /* #64ae6c */,
  "badge-green": "rgba(9, 146, 80, 1)",
  "badge-highlight-green": "rgba(237, 252, 242, 1)",
  "granny-apple": "rgba(210, 244, 233, 1)" /* #D2F4E9 */,
  success: "rgba(37, 198, 134, 1)" /* #25C686 */,
  powurlineGreen: "#12D4A6",
  hunterGreen: "#107569",
  badgeTeal: "#DDF3F4",
  darkBadgeTeal: "#1E9C9E",
  mintCream: "rgba(240, 253, 249, 1)" /* #F0FDF9 */,
  emerald: "rgba(16, 185, 129, 1)" /* #10B981 */,
  teal: "rgba(20, 184, 166, 1)" /* #14B8A6 */,
  tealDark: "rgba(0, 128, 107, 1)" /* #00806B */,
  sanFelixGreen: "rgba(46, 125, 50, 1)" /* #2E7D32 */,
  honeydew: "rgba(232, 245, 233, 1)" /* #E8F5E9 */,
  magicMint: "rgba(167, 243, 208, 1)" /* #A7F3D0 */,
  honeydewLight: "rgba(240, 255, 244, 1)" /* #F0FFF4 */,
  honeydewLighter: "rgba(232, 252, 240, 1)" /* #E8FCF0 */,
  seatBannerTeal: "#D0EDF0",
  darkSeatBannerTeal: "#17868A",
  mintCreamGreen: "rgba(200, 230, 201, 1)" /* #C8E6C9 */,
  lightMintGreen: "rgba(209, 250, 229, 1)" /* #D1FAE5 */,
  darkEmerald: "rgba(6, 95, 70, 1)" /* #065F46 */,
  watercourseGreen: "#017A56",
};

const greyscale = {
  "disabled-grey": "rgba(0, 0, 0, 0.26)",
  "dark-charcoal": "rgb(36, 35, 35)" /*  #242323 */,
  "table-grey": "rgb(51, 51, 51)" /*  #333333 */,
  "text-dark": "#555555",
  "slate-grey": "rgb(78, 79, 80)" /*  #4E4F50 */,
  "slate-grey-a10": "rgba(78, 79, 80, 0.1)" /*  #4E4F50 */,
  "table-badge-unread": "#666" /*  rgba(102, 102, 102, 1) */,
  "slate-grey-a65": "rgba(78, 79, 80, 0.65)",
  "table-badge-total": "rgba(170, 170, 170, 1)" /* #AAAAAA */,
  "silver-grey": "rgba(204, 204, 204, 1)" /*  #CCC */,
  "old-grey": "#ced1d3",
  "old-grey-highlighted": "#dbdee0",
  silver: "rgba(221, 221, 221, 1)" /* #DDDDDD */,
  white: "rgba(255, 255, 255, 1)" /* #ffffff (css "white") */,
  "white-a65": "rgba(255, 255, 255, 0.65)" /* #ffffff */,
  whiteA03: "rgba(255, 255, 255, 0.03)",
  whiteA05: "rgba(255, 255, 255, 0.05)",
  whiteA06: "rgba(255, 255, 255, 0.06)",
  whiteA08: "rgba(255, 255, 255, 0.08)",
  whiteA10: "rgba(255, 255, 255, 0.10)",
  whiteA12: "rgba(255, 255, 255, 0.12)",
  whiteA40: "rgba(255, 255, 255, 0.40)",
  whiteA55: "rgba(255, 255, 255, 0.55)",
  whiteA85: "rgba(255, 255, 255, 0.85)",
  "table-edit-mode": "rgba(243, 248, 255, 1)" /* #F3F8FF */,
  grey: "rgb(241, 245, 248)" /* #F1F5F8: POWUR GUIDE PRIMARY-4 (see catskillWhite) */,
  "graham-grey": "rgba(177, 194, 217, 1)" /* #B1C2D9 */,
  "athens-gray": "rgba(250, 251, 252, 1)" /* #FAFBFC */,
  "light-grey": "rgb(217, 234, 253)" /* #D9EAFD */,
  "light-grey-a65": "rgba(217, 234, 253, 0.65)",
  "light-grey-a25": "rgba(217, 234, 253, 0.25)",
  "lighter-grey": "rgb(239, 240, 241)" /*  #EFF0F1 */,
  "lighter-grey-a65": "rgba(239, 240, 241, 0.65)",
  "lightest-grey": "rgb(248, 248, 248)" /* #f8f8f8", */,
  gainsboro: "rgb(225, 225, 225)" /* #E1E1E1 */,
  cream: "#f5f7f9",
  "alabaster-white": "rgba(249, 249, 249, 1)" /*  #F9F9F9 */,
  "ma-white": "rgb(245, 248, 255)" /* #F5F8FF */,
  "ma-white-a22": "rgba(245, 248, 255, 0.22)" /* #F5F8FF */,
  "gallery-white": "rgba(238, 238, 238, 1)" /*  #EEE */,
  "trolley-grey": "rgb(130,130,130)" /* #828282 */,
  "hammerhead-grey": "#888888",
  "dark-grey": "rgba(112, 112, 112, 1)" /* #707070 */,
  "light-silver": "rgba(217, 217, 217, 1)" /* #D9D9D9 */,
  "bright-gray": "rgba(231, 237, 246, 1)" /* #E7EDF6 */,
  "ghost-white": "rgba(246, 249, 250, 1)" /* #F6F9FA */,
  "hit-gray": "rgba(167, 180, 185, 1)" /* #A7B4B9 */,
  "loblolly-gray": "rgba(179, 189, 199, 1)" /* #B3BDC7 */,
  "mineshaft-gray": "rgba(58, 58, 58, 1)" /* #3A3A3A */,
  "dusty-gray": "rgba(153, 153, 153, 1)" /* #999999 */,
  "tundora-gray": "rgba(75, 75, 75, 1)" /* #4B4B4B */,
  "regent-gray": "rgba(128, 145, 161, 1)" /* #8091A1 */,
  "binrouji-black": "rgba(68, 61, 61, 1)" /* #443D3D */,
  "raisin-black": "rgba(34, 34, 34, 1)" /* #222222 */,
  "bleached-silk": "rgba(242, 242, 242, 1)" /* #F2F2F2 */,
  "twinkle-gray": "rgba(171, 200, 211, 1)" /* #ABC8D3 */,
  catskillWhiteA50: "rgba(241, 245, 248, 0.5)" /* #F1F5F8: POWUR GUIDE PRIMARY-4 */,
  "brilliant-white": "rgba(230, 241, 254, 1)" /* #E6F1FE */,
  "maui-mist": "rgba(239, 243, 245, 1)" /* #EFF3F5 */,
  "american-silver": "rgba(206, 206, 206, 1)" /* #CECECE */,
  "emptiness-white": "rgba(252, 252, 252, 1)" /* #FCFCFC */,
  "lynx-white": "rgba(247, 247, 247, 1)" /* #F7F7F7 */,
  "white-smoke": "rgba(245, 245, 245, 1)" /* #F5F5F5 */,
  "cultured-white": "rgba(246, 247, 249, 1)" /* #F6F7F9 */,
  "lead-black": "rgba(32, 32, 32, 1)" /* #202020 */,
  "light-gravel": "rgba(187, 187, 187, 1)" /* #BBBBBB */,
  "errigal-white": "rgba(240, 242, 245, 1)" /* #F0F2F5 */,
  "explosive-gray": "rgba(196, 196, 196, 1)" /* #C4C4C4 */,
  "philippine-silver": "rgba(179, 180, 181, 1)" /* #B3B4B5 */,
  "porcelain-white": "rgba(233, 234, 235, 1)" /* #E9EAEB */,
  "moustache-gray": "rgba(126, 126, 126, 1)" /* #7E7E7E */,
  "spanish-gray": "rgba(152, 152, 152, 1)" /* #989898 */,
  "wizard-white": "rgba(226, 239, 254, 1)" /* #E2EFFE */,
  "gallery-gray": "rgba(240, 240, 240, 1)" /* #F0F0F0 */,
  "distant-horizon": "rgba(240, 246, 251, 1)" /* #F0F6FB */,
  "whale-white": "rgba(242, 243, 244, 1)" /* #F2F3F4 */,
  "unbleached-white": "rgba(253, 250, 244, 1)" /* #FDFAF4 */,
  "nevada-gray": "rgba(94, 103, 108, 1)" /* #5E676C: POWUR GUIDE SECONDARY-4 */,
  "fiord-gray": "#405169",
  badges: "#EAECF5",
  sanJuanGray: "rgba(140, 152, 169, 1)" /* #8C98A9 */,
  "sanJuanGray-a10": "rgba(140, 152, 169, 0.1)" /* #8C98A9 */,
  solitudeGray: "rgba(232, 236, 241, 1)" /* #E8ECF1 */,
  ghostWhiteBlue: "rgba(248, 250, 252, 1)" /* #F8FAFC */,
  mischkaGray: "rgba(224, 232, 240, 1)" /* #E0E8F0 */,
  whisperGray: "rgba(240, 243, 247, 1)" /* #F0F3F7 */,
  culturedGray: "rgba(248, 249, 250, 1)" /* #F8F9FA */,
  cadetGray: "rgba(192, 200, 208, 1)" /* #C0C8D0 */,
  rockBlueGray: "rgba(139, 155, 180, 1)" /* #8B9BB4 */,
  lightSteelGray: "rgba(204, 213, 224, 1)" /* #CCD5E0 */,
  paleBlueGray: "rgba(198, 211, 227, 1)" /* #C6D3E3 */,
  paleCloudBlue: "rgba(238, 243, 248, 1)" /* #EEF3F8 */,
  coolGray: "rgba(154, 166, 175, 1)" /* #9AA6AF */,
  geyserGray: "rgba(221, 227, 233, 1)" /* #DDE3E9 */,
  mysticBlue: "rgba(225, 235, 245, 1)" /* #E1EBF5 */,
  oliveBlack: "rgba(26, 16, 0, 1)" /* #1A1000 */,
  ghostWhite: "rgba(248, 250, 251, 1)" /* #F8FAFB */,
  aliceBlue: "rgba(227, 242, 253, 1)" /* #E3F2FD */,
  zirconGray: "rgba(245, 247, 250, 1)" /* #F5F7FA */,
  whisperWhite: "rgba(243, 244, 246, 1)" /* #F3F4F6 */,
  selago: "rgba(240, 244, 248, 1)" /* #F0F4F8 */,
  slateGray: "rgba(148, 163, 184, 1)" /* #94A3B8 */,
  linkWaterGray: "rgba(232, 237, 242, 1)" /* #E8EDF2 */,
  bombayGrayA25: "rgba(177, 181, 184, 0.25)",
  bombayGray: "#B1B5B8",
  frostWhite: "#FAFCFD",
  linkWater: "#E9EFF5",
  mysticGray: "#EAF0F6",
  regentGray: "#8A949C",
};

const oranges = {
  "sunset-orange": "rgba(255, 77, 79, 1)" /* #FF4D4F */,
  "mango-orange": "rgba(249, 166, 0, 1)" /* #F9A600 */,
  "tangerine-orange": "rgba(232, 140, 2, 1)" /* #E88C02 */,
  "sunray-orange": "rgba(230, 178, 79, 1)" /* #E6B24F */,
  "equator-orange-a07": "rgba(227, 181, 91, 0.07)" /* #E3B55B12 */,
  "sunnova-orange": "rgba(255, 142, 40, 1)" /* #ff8e28 */,
  "warning-orange": "rgba(255, 229, 205, 1)" /* #FFE5CD */,
  "tango-orange": "rgba(244, 120, 37, 1)" /* #F47825 */,
  lightYellow: "#FEFBE8",
  burntOrange: "#C78100",
  deepOrange: "rgba(230, 81, 0, 1)" /* #E65100 */,
  rawUmber: "rgba(184, 92, 0, 1)" /* #B85C00 */,
  oldLace: "rgba(255, 243, 224, 1)" /* #FFF3E0 */,
  navajoWhite: "rgba(255, 224, 178, 1)" /* #FFE0B2 */,
  seashell: "rgba(255, 248, 240, 1)" /* #FFF8F0 */,
  linenLight: "rgba(252, 240, 232, 1)" /* #FCF0E8 */,
  amberLight: "rgba(254, 243, 199, 1)" /* #FEF3C7 */,
  amberDark: "rgba(180, 83, 9, 1)" /* #B45309 */,
  saddleBrown: "rgba(146, 64, 14, 1)" /* #92400E */,
  tahitiGoldA14: "rgba(223, 107, 0, 0.14)",
  maiTaiBrown: "#A85408",
};

const purples = {
  eggplant: "rgba(72, 38, 210, 1)" /* #4826D2 */,
  "eggplant-a10": "rgba(72, 38, 210, 0.1)" /* #4826D2 */,
  "venetian-nights": "rgba(125, 92, 255, 1)" /* #7D5CFF */,
  "electric-violet": "rgba(130, 83, 254, 1)" /* #8253FE */,
  "trusted-purple": "rgba(99, 12, 208, 1)" /* #630CD0 */,
  violetEggplant: "rgba(153, 17, 163, 1)" /* #9911A3 */,
  auberginePerl: "rgba(89, 4, 172, 1)" /* #5904AC */,
  "lavender-phlox": "#F7F9FC",
  magnolia: "rgba(237, 231, 246, 1)" /* #EDE7F6 */,
  moonRaker: "rgba(209, 196, 233, 1)" /* #D1C4E9 */,
  lavenderPurpleA20: "rgba(149, 116, 255, 0.20)",
  melrosePurple: "#C7B6FF",
};

const cyans = {
  lightCyanBg: "rgba(224, 247, 250, 1)" /* #E0F7FA */,
  blizzardBlue: "rgba(178, 235, 242, 1)" /* #B2EBF2 */,
  skyCyan: "#3DC6F2",
  skyCyanA20: "rgba(61, 198, 242, 0.20)",
  brightSky: "#3AD4FF",
  iceCyan: "#76DCFF",
  powurTealA18: "rgba(81, 242, 203, 0.18)",
  powurTealA53: "rgba(81, 242, 203, 0.53)",
  riptideTeal: "#76EFCA",
};

const colors = {
  ...blues,
  ...yellows,
  ...reds,
  ...greens,
  ...greyscale,
  ...oranges,
  ...purples,
  ...cyans,
};

const gradients = {
  brandPrimaryGradient: `linear-gradient(95.7deg, ${colors["picton-blue"]} 12.17%, ${colors["blue-ribbon"]} 93.24%)`,
  brandReverseGradient: `linear-gradient(270.54deg, ${colors["picton-blue"]} 49.88%, ${colors["blue-ribbon"]} 135.73%)`,
  nightGradient: `linear-gradient(135deg, ${colors["darkest-blue"]} 0%, ${colors.bayOfManyBlue} 40%, ${colors.toryBlue} 70%, ${colors["congress-blue"]} 100%)`,
  tileGradient: `linear-gradient(321.72deg, ${colors["picton-blue"]} 29.8%, ${colors["blue-ribbon"]} 116.18%)`,
  vibrantBlueGradient: `linear-gradient(90deg, ${colors["blue-ribbon"]} 0%, ${colors["picton-blue"]} 100%)`,
  blueTealGradient: `linear-gradient(90deg, ${colors["blue-ribbon"]} 0%, ${colors.powurTealA53} 100%)`,
  goldFadeGradient: `linear-gradient(90deg, ${colors.goldenrod} 3.39%, transparent 123.66%)`,
  skyFadeGradient: `linear-gradient(180deg, ${colors["polar-blue"]} 0%, ${colors.white} 100%)`,
  navActiveGradientLight: `linear-gradient(95.7deg, ${colors.pictonBlueA12} 12%, ${colors["blue-ribbon-a10"]} 93%)`,
  navActiveGradientDark: `linear-gradient(95.7deg, ${colors["picton-blue-a20"]} 12%, ${colors.blueRibbonA18} 93%)`,
  slideBgGradientDark: `linear-gradient(135deg, ${colors.midnightNavy} 0%, ${colors.sapphireMid} 100%)`,
  slideOverlayGradientLight: `radial-gradient(500px 400px at 12% -10%, ${colors.pictonBlueA18}, transparent 60%),radial-gradient(600px 400px at 100% 110%, ${colors["blue-ribbon-a10"]}, transparent 60%)`,
  slideOverlayGradientDark: `radial-gradient(500px 400px at 12% -10%, ${colors["picton-blue-a20"]}, transparent 60%),radial-gradient(600px 400px at 100% 110%, ${colors.blueRibbonA18}, transparent 60%)`,
  pageBgGradientDark: `linear-gradient(180deg, ${colors.eclipseNavy} 0%, ${colors.midnightNavy} 100%)`,
  pageOverlayGradientDark: `radial-gradient(600px 500px at 92% -10%, ${colors.blueRibbonA18}, transparent 60%), radial-gradient(700px 600px at -5% 100%, ${colors["picton-blue-a10"]}, transparent 60%)`,
  btnPrimaryHoverGradientDark: `linear-gradient(95.7deg, ${colors.brightSky} 12%, ${colors.azureBright} 93%)`,
  tileFeatureGradientDark: `linear-gradient(135deg, ${colors.sapphireMid} 0%, ${colors.deepSapphire} 100%)`,
  upsellGradient: `linear-gradient(135deg, ${colors["blue-ribbon"]} 0%, ${colors["congress-blue"]} 100%)`,
};

type TGradients = typeof gradients;

const cvar = (name: keyof typeof colors) => `var(--${name})`;
type TColors = typeof colors;

const semanticTokensLight = {
  "c-page-bg": colors.grey,
  "c-page-overlay": "none",
  "c-page-overlay-opacity": "1",
  "c-sidebar-bg": colors.white,
  "c-sidebar-blur": "none",
  "c-topbar-bg": colors.whiteA85,
  "c-topbar-blur": "blur(10px)",
  "c-card-bg": colors.white,
  "c-card-border": "transparent",
  "c-card-shadow": "0 4px 12px rgba(0,0,0,0.03)",
  "c-card-blur": "none",
  "c-panel-header-bg": colors.ghostWhiteBlue,
  "c-table-head-bg": colors.frostWhite,
  "c-row-hover-bg": colors.frostWhite,
  "c-input-bg": colors.grey,
  "c-input-border": colors["botticelli-blue"],
  "c-input-hover-bg": colors.linkWater,
  "c-chip-bg": colors.white,
  "c-chip-border": colors["botticelli-blue"],
  "c-chip-hover-bg": colors.grey,
  "c-chip-active-bg": colors.blueRibbonA08,
  "c-chip-active-border": colors.blueRibbonA22,
  "c-border": colors["botticelli-blue"],
  "c-border-soft": colors.mysticGray,
  "c-text-strong": colors["darkest-blue"],
  "c-text-body": colors["slate-grey"],
  "c-text-muted": colors["nevada-gray"],
  "c-text-faint": colors.regentGray,
  "c-text-disabled": colors.bombayGray,
  "c-text-success": colors.watercourseGreen,
  "c-text-warn": colors.amberDark,
  "c-nav-text": colors["slate-grey"],
  "c-nav-hover-bg": colors.grey,
  "c-nav-active-bg": gradients.navActiveGradientLight,
  "c-nav-active-shadow": "none",
  "c-accent": colors["blue-ribbon"],
  "c-accent-glow": colors.blueRibbonA12,
  "c-success": colors["green-haze"],
  "c-warning": colors["status-alert-fill"],
  "c-logo-filter": "none",
  "c-btn-primary-bg": colors["blue-ribbon"],
  "c-btn-primary-hover-bg": colors["banner-blue"],
  "c-btn-primary-shadow": "0 0.5px 2px rgba(0,0,0,0.15)",
  "c-btn-outline-bg": colors.white,
  "c-btn-outline-border": colors["blue-ribbon"],
  "c-btn-subtle-border": colors.paleBlueGray,
  "c-btn-outline-hover-bg": colors.grey,
  "c-quick-bg": colors.white,
  "c-quick-hover-bg": colors.grey,
  "c-quick-ico-shadow": "0 4px 14px rgba(0,112,244,0.40)",
  "c-progress-track": colors.mysticGray,
  "c-init-bg": colors["polar-blue"],
  "c-init-border": colors["botticelli-blue"],
  "c-b-new-bg": colors["blue-ribbon-a10"],
  "c-b-new-fg": colors.cobaltBright,
  "c-b-accepted-bg": colors["eggplant-a10"],
  "c-b-accepted-fg": colors.eggplant,
  "c-b-await-bg": colors.nepalBlueA20,
  "c-b-await-fg": colors.lynchBlue,
  "c-b-closed-bg": colors.greenHazeA12,
  "c-b-closed-fg": colors.watercourseGreen,
  "c-b-offer-bg": colors.tahitiGoldA14,
  "c-b-offer-fg": colors.maiTaiBrown,
  "c-b-cancel-bg": colors.bombayGrayA25,
  "c-b-cancel-fg": colors["nevada-gray"],
  "c-b-draft-bg": colors.goldenrodA22,
  "c-b-draft-fg": colors.amberDark,
  "c-slide-bg": gradients.skyFadeGradient,
  "c-slide-border": colors["botticelli-blue"],
  "c-slide-eye": colors["blue-ribbon"],
  "c-slide-overlay": gradients.slideOverlayGradientLight,
  "c-slide-shadow": "0 4px 18px rgba(0, 33, 96, 0.08)",
  "c-slide-stat-bg": colors.whiteA85,
  "c-slide-stat-blur": "blur(6px)",
  "c-slide-stat-border": colors["botticelli-blue"],
  "c-slide-stat-label": colors["nevada-gray"],
  "c-slide-stat-value": colors["darkest-blue"],
  "c-slide-text": colors["darkest-blue"],
  "c-tile-feature-bg": colors.white,
  "c-tile-feature-border": "transparent",
  "c-tile-feature-glow": colors.pictonBlueA22,
  "c-tile-feature-shadow": "0 4px 15px 0 rgba(0,112,244,0.20)",
  "c-upsell-bg": gradients.upsellGradient,
  "c-upsell-border": "transparent",
  "c-avatar-shadow": "none",
};

const semanticTokensDark = {
  "c-page-bg": gradients.pageBgGradientDark,
  "c-page-overlay": gradients.pageOverlayGradientDark,
  "c-page-overlay-opacity": "1",
  "c-sidebar-bg": colors.oxfordNavy,
  "c-sidebar-blur": "none",
  "c-topbar-bg": colors.oxfordNavyA92,
  "c-topbar-blur": "blur(8px)",
  "c-card-bg": colors.deepSapphire,
  "c-card-border": colors.whiteA05,
  "c-card-shadow": "0 8px 24px rgba(0,0,0,0.35)",
  "c-card-blur": "none",
  "c-panel-header-bg": colors.midnightSapphire,
  "c-table-head-bg": colors.midnightSapphire,
  "c-row-hover-bg": colors.whiteA03,
  "c-input-bg": colors.navyInk,
  "c-input-border": colors.whiteA08,
  "c-input-hover-bg": colors.sapphireBlue,
  "c-chip-bg": colors.navyInk,
  "c-chip-border": colors.whiteA08,
  "c-chip-hover-bg": colors.sapphireBlue,
  "c-chip-active-bg": colors.pictonBlueA18,
  "c-chip-active-border": colors.pictonBlueA40,
  "c-border": colors.whiteA10,
  "c-border-soft": colors.whiteA05,
  "c-text-strong": colors.zirconWhite,
  "c-text-body": colors.casperBlue,
  "c-text-muted": colors.baliHaiBlue,
  "c-text-faint": colors.kashmirBlue,
  "c-text-disabled": colors.whiteA40,
  "c-text-success": colors.riptideTeal,
  "c-text-warn": colors.salomieGold,
  "c-nav-text": colors.casperBlue,
  "c-nav-hover-bg": colors.royalNavy,
  "c-nav-active-bg": gradients.navActiveGradientDark,
  "c-nav-active-shadow": "inset 2px 0 0 #20C2F1",
  "c-accent": colors.skyCyan,
  "c-accent-glow": colors.skyCyanA20,
  "c-success": colors["sweet-mint"],
  "c-warning": colors.goldenrod,
  "c-logo-filter": "brightness(0) invert(1)",
  "c-btn-primary-bg": gradients.brandPrimaryGradient,
  "c-btn-primary-hover-bg": gradients.btnPrimaryHoverGradientDark,
  "c-btn-primary-shadow": "0 2px 12px rgba(0,112,244,0.50), inset 0 1px 0 rgba(255,255,255,0.18)",
  "c-btn-outline-bg": "transparent",
  "c-btn-outline-border": colors.pictonBlueA50,
  "c-btn-subtle-border": colors.pictonBlueA50,
  "c-btn-outline-hover-bg": colors["picton-blue-a10"],
  "c-quick-bg": colors.midnightSapphire,
  "c-quick-hover-bg": colors.cobaltNavy,
  "c-quick-ico-shadow": "0 4px 14px rgba(0,112,244,0.40)",
  "c-progress-track": colors.whiteA08,
  "c-init-bg": colors.pictonBlueA12,
  "c-init-border": colors.pictonBlueA30,
  "c-b-new-bg": colors.pictonBlueA18,
  "c-b-new-fg": colors.iceCyan,
  "c-b-accepted-bg": colors.lavenderPurpleA20,
  "c-b-accepted-fg": colors.melrosePurple,
  "c-b-await-bg": colors.nepalBlueA18,
  "c-b-await-fg": colors.periwinkleGray,
  "c-b-closed-bg": colors.powurTealA18,
  "c-b-closed-fg": colors.riptideTeal,
  "c-b-offer-bg": colors.goldenrodA20,
  "c-b-offer-fg": colors.salomieGold,
  "c-b-cancel-bg": colors.whiteA08,
  "c-b-cancel-fg": colors.spindleBlue,
  "c-b-draft-bg": colors.goldenrodA20,
  "c-b-draft-fg": colors.salomieGold,
  "c-slide-bg": gradients.slideBgGradientDark,
  "c-slide-border": colors.pictonBlueA30,
  "c-slide-eye": colors.skyCyan,
  "c-slide-overlay": gradients.slideOverlayGradientDark,
  "c-slide-shadow": "0 8px 28px rgba(0, 0, 0, 0.45)",
  "c-slide-stat-bg": colors.whiteA06,
  "c-slide-stat-blur": "none",
  "c-slide-stat-border": colors.whiteA12,
  "c-slide-stat-label": colors.whiteA55,
  "c-slide-stat-value": colors.white,
  "c-slide-text": colors.white,
  "c-tile-feature-bg": gradients.tileFeatureGradientDark,
  "c-tile-feature-border": colors.pictonBlueA45,
  "c-tile-feature-glow": colors.pictonBlueA30,
  "c-tile-feature-shadow": "0 8px 28px rgba(0,112,244,0.45), inset 0 1px 0 rgba(255,255,255,0.06)",
  "c-upsell-bg": gradients.upsellGradient,
  "c-upsell-border": colors.pictonBlueA30,
  "c-avatar-shadow": "0 0 0 1px rgba(32,194,241,0.40)",
};

const staticTokens = {
  "status-new": colors["blue-ribbon"],
  "status-accepted": colors.eggplant,
  "status-awaiting-proposal": colors["nepal-blue"],
  "status-closed": colors["green-haze"],
  "status-canceled": colors.bombayGray,
  "status-pending": colors["graham-grey"],
  "status-view-offer": colors["status-alert-fill"],
  "shadow-card": "0 4px 12px rgba(0,0,0,0.03)",
  "shadow-tooltip": "0 4px 12px rgba(0,0,0,0.15)",
  "shadow-tile-active": "0 4px 15px rgba(0,112,244,0.31)",
  "shadow-button": "0px 2px 3px 0 rgba(120, 120, 120, 0.5)",
  "shadow-button-sm": "0px 1px 2px 0 rgba(120, 120, 120, 0.5)",
  "shadow-button-xs": "0px 0.5px 2px rgba(0, 0, 0, 0.15)",
  "space-1": "4px",
  "space-2": "8px",
  "space-3": "12px",
  "space-4": "16px",
  "space-5": "20px",
  "space-6": "24px",
  "space-7": "32px",
  "space-8": "40px",
  "space-9": "48px",
  "space-10": "64px",
  "radius-sm": "3px",
  "radius-md": "4px",
  "radius-button": "6px",
  "radius-lg": "12px",
  "radius-xl": "16px",
  "radius-2xl": "24px",
  "radius-pill": "999px",
  "motion-fast": "120ms cubic-bezier(0.4, 0, 0.2, 1)",
  "motion-base": "200ms cubic-bezier(0.4, 0, 0.2, 1)",
  "motion-slow": "320ms cubic-bezier(0.2, 0, 0, 1)",
  "motion-easing": "cubic-bezier(0.4,0,0.2,1)",
};

type TSemanticTokens = typeof semanticTokensLight;

const THEME_STYLE_ID = "powur-theme-tokens";

const applyRootVars = (root: HTMLElement, tokens: Record<string, string>) => {
  Object.entries(tokens).forEach(([name, value]) => {
    root.style.setProperty(`--${name}`, value);
  });
};

const toCssVarRules = (tokens: Record<string, string>) =>
  Object.entries(tokens)
    .map(([name, value]) => `  --${name}: ${value};`)
    .join("\n");

const getThemeStyleEl = () => {
  const existing = document.getElementById(THEME_STYLE_ID) as HTMLStyleElement | null;
  if (existing) {
    return existing;
  }
  const styleEl = document.createElement("style");
  styleEl.id = THEME_STYLE_ID;
  document.head.appendChild(styleEl);
  return styleEl;
};

const configureColorVars = () => {
  const root = document.documentElement;

  applyRootVars(root, colors);
  applyRootVars(root, staticTokens);
  applyRootVars(root, gradients);

  getThemeStyleEl().textContent =
    `:root, html[data-theme="light"] {\n${toCssVarRules(semanticTokensLight)}\n}\n` +
    `html[data-theme="dark"] {\n${toCssVarRules(semanticTokensDark)}\n}`;

  if (!root.hasAttribute("data-theme")) {
    root.setAttribute("data-theme", "light");
  }
};

export {
  colors,
  gradients,
  configureColorVars,
  cvar,
  semanticTokensLight,
  semanticTokensDark,
  staticTokens,
  TColors,
  TGradients,
  TSemanticTokens,
};
